import React, { useEffect } from 'react';
import AppRouter from './components/Router';
import { Toaster } from 'react-hot-toast';
import { AdminProvider } from './context/AdminContext';
import { AuthSessionProvider } from './context/AuthSessionContext';
import { EmergencyEventProvider } from './context/EmergencyEventContext';
import EmergencyAlertModal from './components/EmergencyAlertModal';
import Footer from './components/Footer';
import './css/Footer.css';

const App = () => {
  useEffect(() => {
    // 다크모드 제거: 항상 라이트 모드 유지
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);


  return (
    <AuthSessionProvider>
      <AdminProvider>
        <EmergencyEventProvider>
          <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Toaster position="top-right" />
            <div style={{ flex: 1 }}>
              <AppRouter />
            </div>
            <Footer />
          </div>
          <EmergencyAlertModal />
        </EmergencyEventProvider>
      </AdminProvider>
    </AuthSessionProvider>
  );
};

export default App;
